export default __webpack_public_path__ + "static/media/chatImage.360da808.png";